import React from "react";
import { PacmanLoader } from "react-spinners";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { GenericTable } from "components/GenericTable";
import EditableCell from "containers/common/EditableCell";
import "containers/common/List.css";
import "containers/common/Table.css";

import {
  createColumnHelper,
} from "@tanstack/react-table";

function QueryList({
  data,
  isLoading,
  isAuthenticated,
  controlType,
  saveRecord,
  deleteRecord,
  updateTableState,
  propertyId,
  validateRelatedRecord,
}) {

  const dataSet = "queries";

  const tableData = Array.isArray(data) ? data : [];
  const columnHelper = createColumnHelper();

  const tableMeta = {
    updateData: (rowIndex, columnId, value) => {
      updateTableState(dataSet, rowIndex, columnId, value);
    },
    handleSave: async ({ row, column, value }) => {
      const record = {
        ...row.original,
        ...(column?.id ? { [column.id]: value } : {}),
      };

      const validation = validateRelatedRecord?.(record, dataSet) || [true, null];
      if (validation[0] !== true) {
        window.alert(validation[1] || "Validation failed");
        return { validationFailed: true };
      }

      try {
        await saveRecord(dataSet, record);
        return { skipLocalUpdate: true };
      } catch (err) {
        console.error("Query save failed:", err);
        return { saveFailed: true };
      }
    },
    handleDelete: async ({ row }) => {
      await deleteRecord(dataSet, row.original);
    },
  };

  const columns = [
    columnHelper.accessor("query_id", {
      id: "query_id",
      header: "ID",
      cell: (cellContext) => {
        const queryId = cellContext.getValue();
        const propertyKey = cellContext.row.original?.property_key;

        return (
          <Link
            to={`/properties/${propertyKey}/queries/${queryId}`}
            state={{ data: tableData.map((query) => query.query_id) }}
          >
            {queryId}
          </Link>
        );
      },
      size: 30,
    }),
    columnHelper.accessor("date_to_resolve", {
      id: "date_to_resolve",
      header: "Date to Resolve",
      cell: EditableCell,
      meta: {
        align: "center",
      },
      size: 50,
    }),
    columnHelper.accessor("type", {
      id: "type",
      header: "Type",
      size: 50,
    }),
    columnHelper.accessor("active", {
      id: "active",
      header: "Active",
      cell: EditableCell,
      meta: {
        align: "center",
      },
      size: 50,
    }),
    columnHelper.accessor("perpetual", {
      id: "perpetual",
      header: "Perpetual",
      cell: EditableCell,
      meta: {
        align: "center",
      },
      size: 50,
    }),
    columnHelper.accessor("problem", {
      id: "problem",
      header: "Problem",
      cell: EditableCell,
      size: 250,
    }),
    columnHelper.display({
      id: "delete_query_id",
      header: "",
      cell: ({ row }) => (
        <Button
          type="button"
          size="sm"
          variant="danger"
          onClick={async () => {
            const confirmed = window.confirm("Are you sure you want to delete this record?");
            if (!confirmed) {
              return;
            }
            await tableMeta.handleDelete({ row });
          }}
        >
          Delete
        </Button>
      ),
      size: 65,
    }),
  ];

  function renderComponent() {
    return (
      <div className="componentRendering">
        <Row>
          <Col className="text-right">
            <Link to={`/properties/${propertyId}/queries/new`}>
              <Button variant="secondary" size="sm">Add</Button>
            </Link>
          </Col>
        </Row>

        <Row className="show-Container">
          <Col sm={12} md={12} lg={12}>
            {isLoading && (
              <div className="outer-div">
                <div className="sweet-loading inner-div">
                  <PacmanLoader
                    cssOverride={{ display: "block", margin: "0 auto" }}
                    size={20}
                    color={"#e03c31"}
                    loading={isLoading}
                  />
                </div>
              </div>
            )}
            {!isLoading && (
              <GenericTable
                data={tableData}
                columns={columns}
                meta={tableMeta}
                pageSize={10}
                hasHeaderSorting={true}
              />
            )}
          </Col>
        </Row>
      </div>
    );
  }
  return (
    <div className="QueryList">
      {isAuthenticated ? renderComponent() : console.log("User not authenticated.")}
    </div>
  );
}

export default QueryList;